"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _H = _interopRequireDefault(require("../elements/headings/H2"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UIFormControl = _interopRequireDefault(require("../form/UIFormControl"));

var _UIModalDialog = _interopRequireDefault(require("./UIModalDialog"));

var _UIDialogBody = _interopRequireDefault(require("./UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("./UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("./UIDialogHeader"));

var _UIMatchTextArea = _interopRequireDefault(require("../input/UIMatchTextArea"));

var _PromptablePropInterface = _interopRequireDefault(require("../decorators/PromptablePropInterface"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var CONFIRM = 'confirm';
var REJECT = 'reject';

var UIConfirmDialog = _react.default.createClass({
  displayName: "UIConfirmDialog",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UIModalDialog.default.propTypes, 'onEsc'), {
    ConfirmButton: _component.default,
    confirmButtonProps: _react.PropTypes.object,
    confirmLabel: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
    confirmUse: _UIButton.default.propTypes.use,
    defaultAction: _react.PropTypes.oneOf([CONFIRM, REJECT]),
    description: _react.PropTypes.node,
    disableConfirm: _react.PropTypes.bool,
    match: _react.PropTypes.string,
    matcherLabel: _react.PropTypes.node,
    message: _react.PropTypes.node.isRequired,
    onConfirm: _PromptablePropInterface.default.onConfirm,
    onReject: _PromptablePropInterface.default.onReject,
    RejectButton: _component.default,
    rejectButtonProps: _react.PropTypes.object,
    rejectLabel: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
    rejectUse: _UIButton.default.propTypes.use
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIModalDialog.default.defaultProps, {
      ConfirmButton: _UIButton.default,
      confirmLabel: function confirmLabel() {
        return _I18n.default.text('salesUI.UIConfirm.defaultConfirm');
      },
      confirmUse: 'primary',
      defaultAction: REJECT,
      RejectButton: _UIButton.default,
      rejectLabel: function rejectLabel() {
        return _I18n.default.text('salesUI.UIConfirm.defaultReject');
      },
      rejectUse: 'tertiary-light',
      role: 'alertdialog'
    });
  },
  getInitialState: function getInitialState() {
    return {
      isMatched: false
    };
  },
  handleConfirm: function handleConfirm() {
    this.props.onConfirm(true);
  },
  handleMatchedChange: function handleMatchedChange(_ref) {
    var value = _ref.target.value;
    this.setState({
      isMatched: value
    });
  },
  handleReject: function handleReject() {
    this.props.onReject(false);
  },
  render: function render() {
    var _this$props = this.props,
        ConfirmButton = _this$props.ConfirmButton,
        confirmButtonProps = _this$props.confirmButtonProps,
        confirmLabel = _this$props.confirmLabel,
        confirmUse = _this$props.confirmUse,
        defaultAction = _this$props.defaultAction,
        description = _this$props.description,
        disableConfirm = _this$props.disableConfirm,
        match = _this$props.match,
        matcherLabel = _this$props.matcherLabel,
        message = _this$props.message,
        __onConfirm = _this$props.onConfirm,
        __onReject = _this$props.onReject,
        RejectButton = _this$props.RejectButton,
        rejectButtonProps = _this$props.rejectButtonProps,
        rejectLabel = _this$props.rejectLabel,
        rejectUse = _this$props.rejectUse,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["ConfirmButton", "confirmButtonProps", "confirmLabel", "confirmUse", "defaultAction", "description", "disableConfirm", "match", "matcherLabel", "message", "onConfirm", "onReject", "RejectButton", "rejectButtonProps", "rejectLabel", "rejectUse", "use"]);
    var isMatched = this.state.isMatched;
    return _react.default.createElement(_UIModalDialog.default, (0, _extends2.default)({}, rest, {
      use: use,
      onEsc: this.handleReject
    }), message && use !== 'default' ? _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, null, message)) : null, _react.default.createElement(_UIDialogBody.default, null, use === 'default' ? _react.default.createElement(_H.default, {
      className: "is--heading-4"
    }, message) : null, typeof description === 'string' ? _react.default.createElement("p", null, description) : description, match ? _react.default.createElement("div", {
      className: "private-modal__matcher-outer"
    }, _react.default.createElement(_UIFormControl.default, {
      label: matcherLabel
    }, _react.default.createElement(_UIMatchTextArea.default, {
      match: match,
      onMatchedChange: this.handleMatchedChange,
      size: "xxl"
    }))) : null), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(ConfirmButton, (0, _extends2.default)({
      autoFocus: defaultAction === CONFIRM && !match,
      className: "uiConfirm-button",
      "data-confirm-button": "accept",
      disabled: typeof disableConfirm === 'boolean' ? disableConfirm : !!match && !isMatched,
      onClick: this.handleConfirm,
      use: confirmUse
    }, confirmButtonProps), (0, _lazyEval.default)(confirmLabel)), _react.default.createElement(RejectButton, (0, _extends2.default)({
      autoFocus: defaultAction === REJECT && !match,
      className: "uiConfirm-button",
      "data-confirm-button": "reject",
      onClick: this.handleReject,
      use: rejectUse
    }, rejectButtonProps), (0, _lazyEval.default)(rejectLabel))));
  }
});

var _default = UIConfirmDialog;
exports.default = _default;
module.exports = exports.default;